import dev from './dev.json'
import staging from './staging.json'
import prod from './prod.json'

interface IApiConfig {
  [key: string]: {
    configurations: {
      url: string
      token: string
    }
    apiGateWay: {
      url: string
      xApiKey: string
    }
    sendTo: {
      url: string
      token: string
    }
  }
}

const API_CONFIG: IApiConfig = {
  dev,
  staging,
  prod,
}

const getEnv = () => {
  const hostname = window && window.location && window.location.hostname

  if (/staging/.test(hostname)) {
    return 'staging'
  }
  if (/localhost/.test(hostname)) {
    return 'dev'
  }

  return 'prod'
}

export { API_CONFIG, getEnv }
